export function pwaToastGetter(): string | null {
	if (localStorage instanceof Storage) {
		return localStorage.getItem('clicked_pwa_toast');
	}

	return null;
}
